// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh; /* iPad Safari: the visible height, excluding browser bars */
  width: 100%;
  overflow: hidden;
  background-color: #FAF9F6;
}

.main-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(30, 41, 59, 0.08);
  padding: 0;
  /* Align with content boundary */
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
}

.navbar-left {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 20px;
  padding-left: 20px;
}

.navbar-center {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar-right {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
  padding-right: 20px;
}

.nav-info-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(30, 41, 59, 0.1);
  border-radius: 14px;
  font-size: 13px;
  color: #1E293B;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

.nav-label {
  opacity: 0.6;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-weight: 800;
}

.nav-name-container {
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  mask-image: linear-gradient(to right, transparent, black 15%, black 85%, transparent);
}

.nav-info-text {
  display: inline-block;
  padding-left: 10px;
  color: #1a73e8;
  white-space: nowrap;
}

.nav-info-text.animate {
  animation: marquee-text 10s linear infinite;
}

@keyframes marquee-text {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

.search-wrapper {
  position: relative;
}

.search-suggestion {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 7px 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  font-size: 13px;
  color: #64748b;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;
}

.search-suggestion:hover {
  border-color: #3b82f6;
  background: #f8fafc;
}

.search-suggestion strong {
  color: #1e293b;
  font-weight: 600;
}

.search-suggestion-count {
  margin-left: auto;
  flex-shrink: 0;
  font-size: 11px;
  color: #94a3b8;
}

.search-container {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(30, 41, 59, 0.1);
  border-radius: 12px;
  padding: 6px 14px;
  gap: 8px;
  width: 300px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.01);
}

.search-container:focus-within {
  background: #ffffff;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15), 0 4px 12px rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}

.search-icon {
  color: #94a3b8;
  display: flex;
}

.search-container input {
  border: none;
  outline: none;
  font-size: 14px;
  width: 100%;
  color: #1e293b;
}

.search-controls {
  display: flex;
  align-items: center;
  gap: 4px;
  border-left: 1px solid #e2e8f0;
  padding-left: 8px;
}

.match-count {
  font-size: 12px;
  color: #64748b;
  margin-right: 4px;
}

.search-controls button {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #64748b;
  display: flex;
  border-radius: 4px;
}

.search-controls button:hover:not(:disabled) {
  background: #f1f5f9;
  color: #1e293b;
}

.tool-group {
  display: flex;
  background: transparent;
  padding: 4px;
  gap: 12px;
  align-items: center;
}

.tool-btn {
  background: none;
  border: none;
  color: #5c6b89;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.tool-btn:hover {
  background: rgba(0, 0, 0, 0.03);
  color: #1e293b;
}

.tool-btn.active {
  background: #1E293B;
  color: #fff;
  box-shadow: 0 4px 12px rgba(30, 41, 59, 0.3);
}

.tool-btn.active::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
}

.save-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #1E293B;
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(30, 41, 59, 0.2);
}

.save-btn:hover:not(:disabled) {
  background: #0f172a;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(30, 41, 59, 0.3);
}

.save-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.save-btn.saving {
  opacity: 0.8;
}

.main-content {
  display: flex;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  contain: layout style;
}

.app-empty-state {
  display: flex;
  flex: 1 1;
  min-height: 0;
}


.pdf-view-container {
  min-width: 0;
  overflow: hidden;
  background: #FAF9F6;
  will-change: width;
  display: flex;
  flex-direction: column;
}

.pdf-view-container:not(.is-resizing) {
  transition: width 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.pdf-viewer-outer-wrapper {
  height: 100% !important;
}

.pdf-viewer-container {
  overflow-x: auto;
  overflow-y: auto !important;
  scroll-behavior: auto;
}

/* Custom scrollbar — fixed width so markers overlay it precisely.
   Widened 12px -> 16px; keep SCROLLBAR_W in PDFScrollMarker.js in sync. */
.pdf-viewer-container::-webkit-scrollbar {
  width: 16px;
  height: 16px;
}
/* Firefox has no ::-webkit-scrollbar; "auto" is its wider (non-thin) track. */
.pdf-viewer-container {
  scrollbar-width: auto;
}
.pdf-viewer-container::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.06);
}
.pdf-viewer-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.28);
  border-radius: 7px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
.pdf-viewer-container::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.45);
  border: 2px solid transparent;
  background-clip: padding-box;
}

.layout-resizer {
  width: 6px;
  background: #E2E8F0;
  cursor: col-resize;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  transition: background 0.2s;
  user-select: none;
  will-change: background;
  /* iPad: without this Safari treats the drag as a scroll and cancels it */
  touch-action: none;
  -webkit-user-select: none;
}

/* Invisible wider grab area — the visible bar is only 6px, too thin for a finger */
.layout-resizer::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: -10px;
  right: -10px;
}

.layout-resizer:hover,
.layout-resizer.active {
  background: #94A3B8;
}

.resizer-handle {
  width: 24px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #CBD5E1;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  color: #64748b;
  font-size: 14px;
  pointer-events: none;
  /* Let clicks pass to parent container */
  -webkit-user-select: none;
          user-select: none;
}

.layout-resizer:hover .resizer-handle,
.layout-resizer.active .resizer-handle {
  border-color: #94A3B8;
  color: #475569;
}

.workspace-view-wrapper {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  position: relative;
  overflow: hidden;
  will-change: width;
}

.workspace-view-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: #F4F5F7;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
}

/* Page Jump Modal Styles */
.page-jump-modal {
  background: white;
  width: 320px;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  animation: modalAppear 0.3s ease-out;
}

.page-jump-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
}

.page-jump-header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: #1a202c;
  font-weight: 600;
}

.page-jump-body {
  padding: 24px 20px;
  text-align: center;
}

.page-jump-info {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 20px;
}

.page-jump-input-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.page-jump-input-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 16px;
  text-align: center;
  outline: none;
  transition: border-color 0.2s;
}

.page-jump-input-group input:focus {
  border-color: #1a73e8;
}

.page-jump-go-btn {
  background: #1a73e8;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.page-jump-go-btn:hover {
  background: #1557b0;
}


/* PDF Thumbnail Styles */
.pdf-thumbnail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
}

.pdf-thumbnail-modal {
  background: white;
  width: 90%;
  max-width: 1000px;
  max-height: 85vh;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  animation: modalAppear 0.3s ease-out;
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.pdf-thumbnail-header {
  padding: 16px 24px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
}

.pdf-thumbnail-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #1a202c;
  font-weight: 600;
}

.pdf-thumbnail-header .close-btn {
  background: #f7fafc;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  color: #718096;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.pdf-thumbnail-header .close-btn:hover {
  background: #edf2f7;
  color: #1a202c;
}

.pdf-thumbnail-grid {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  background: #f7fafc;
}

@media (max-width: 900px) {
  .pdf-thumbnail-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 600px) {
  .pdf-thumbnail-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.thumbnail-item-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.thumbnail-container {
  width: 100%;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.thumbnail-box {
  width: 100%;
  aspect-ratio: 0.75;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.thumbnail-container:hover .thumbnail-box {
  border-color: #4a90e2;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transform: translateY(-2px);
}

.thumbnail-box canvas {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.thumbnail-placeholder {
  font-size: 12px;
  color: #a0aec0;
  text-align: center;
  padding: 10px;
}

.thumbnail-label {
  font-size: 13px;
  font-weight: 500;
  color: #4a5568;
}

/* Selection Popup Styles */
.selection-popup {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border-radius: 20px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  position: absolute;
  transform: translateX(-50%);
  z-index: 10000;
  animation: popupFadeIn 0.2s ease-out;
}

@keyframes popupFadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
}

.color-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  padding: 0;
}

.color-btn:hover {
  transform: scale(1.2);
}

.color-btn.none-btn {
  background: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  font-size: 16px;
  color: #666;
  font-weight: bold;
}

/* Divider Line Between PDF and Workspace */
/*.pdf-view-container {
  border-right: 2px solid #000;
}*/

/* Session Highlight Styles */
/* Draggable PDF Tool Panel */
.draggable-pdf-panel {
  transition: border-color 0.2s, box-shadow 0.2s;
}

.draggable-pdf-panel:hover {
  border-color: #bbb;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.panel-btn {
  width: 36px;
  height: 36px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease !important;
}

.panel-btn:hover {
  background: rgba(0, 0, 0, 0.05) !important;
  color: #1a73e8 !important;
  transform: scale(1.05);
}

.panel-btn.active {
  background: #e8f0fe !important;
  color: #1a73e8 !important;
  box-shadow: inset 0 0 0 1px rgba(26, 115, 232, 0.2);
}

.drag-handle {
  opacity: 0.5;
  transition: opacity 0.2s;
}

.draggable-pdf-panel:hover .drag-handle {
  opacity: 1;
}

.vertical-color-picker {
  animation: slideInRight 0.2s ease-out;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Intra-page Collapsing (Slicing) Styles */
.shredded-page {
  position: relative;
  overflow: visible !important;
}

.pdf-page-slice {
  position: absolute;
  left: 0;
  width: 100%;
  overflow: hidden;
  transition: transform 0.36s cubic-bezier(.22, .9, .32, 1), clip-path 0.36s cubic-bezier(.22, .9, .32, 1);
  pointer-events: auto;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.pdf-page-slice canvas,
.pdf-page-slice .textLayer {
  position: absolute;
  top: 0;
  left: 0;
}

.jagged-divider {
  position: absolute;
  left: 0;
  width: 100%;
  height: 20px;
  z-index: 10;
  pointer-events: none;
  background-image: linear-gradient(45deg, transparent 33.333%, #ddd 33.333%, #ddd 66.666%, transparent 66.666%),
    linear-gradient(-45deg, transparent 33.333%, #ddd 33.333%, #ddd 66.666%, transparent 66.666%);
  background-size: 15px 30px;
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.05));
  opacity: 0.8;
}

.fold-indicator {
  position: absolute;
  right: -30px;
  width: 25px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0.5;
  transition: opacity 0.2s;
}

.shredded-page:hover .fold-indicator {
  opacity: 1;
}

.pdf-session-highlight {
  pointer-events: none;
  z-index: 4;
  mix-blend-mode: multiply;
  transition: background-color 0.2s ease;
  border-radius: 2px;
}

.workspace-container {
  touch-action: none;
}

/* Context Bar Styles (New Bottom Navbar) */
.context-bar {
  display: flex;
  width: 100%;
  height: 36px;
  /* Slim professional bar */
  background: #f1f3f4;
  /* Light grey standard toolbar bg */
  border-bottom: 1px solid #dadce0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  z-index: 900;
  overflow: visible;
}

.context-value {
  font-size: 13px;
}

.context-tab.pdf-tab {
  /* This class might be deprecated if we switch structure, but keeping for safety/legacy naming if used elsewhere */
  display: flex;
}

.pdf-tabs-container {
  flex: 0 0 auto;
  /* Width set inline */
  display: flex;
  align-items: center;
  /* clip horizontally so the "Files:" label and tabs can't bleed onto the
     workspace tabs when the PDF panel is collapsed/narrow; y stays visible
     so the overflow dropdown can still open below the bar */
  overflow-x: clip;
  overflow-y: visible;
  background: #ffffff;
  border-right: 1px solid #dadce0;
  z-index: 2;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
  transition: width 0.1s;
  padding-left: 0;
}

/* Reuse workspace-tab-item but ensure it displays correctly in PDF container */
.pdf-tab-active {
  margin-top: 8px;
  /* Alignment */
}

.workspace-tabs-container {
  flex: 1 1;
  display: flex;
  align-items: center;
  overflow: visible; /* must NOT be hidden — inner .workspace-tabs-scroll needs overflow-x: auto */
  background: #ffffff;
}

.workspace-tabs-scroll {
  display: flex;
  align-items: center;
  scrollbar-width: thin;
  /* Firefox */
  scrollbar-color: #ccc #f1f1f1;
}

.workspace-tabs-scroll::-webkit-scrollbar {
  height: 4px;
}

.workspace-tabs-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.workspace-tabs-scroll::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.workspace-tabs-scroll::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

.workspace-tab-item {
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 32px;
  /* Inner tab height */
  margin-right: 6px;
  border-radius: 8px 8px 0 0;
  /* Tab look */
  background: #dfe1e5;
  color: #5f6368;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  margin-top: 8px;
  /* Push down to look like tab on bottom border */
  border-bottom: none;
}

.workspace-tab-item:hover {
  background: #d4d7dc;
}

.workspace-tab-item.active {
  background: #e8f0fe;
  color: #1a73e8;
  border-top: 2px solid #1a73e8;
  border-left: 1px solid #dadce0;
  border-right: 1px solid #dadce0;
  font-weight: 600;
  box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.05);
}

.add-workspace-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #5f6368;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 4px;
}

.add-workspace-btn:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #1a73e8;
}

.context-label {
  padding-left: 16px;
  font-weight: 600;
  color: #5f6368;
  margin-right: 8px;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* Adjust Main Content to not overlap if needed, but flex column handles it */
/* ── Navbar unified toolbar additions ── */
.navbar-section-divider {
  width: 1px;
  height: 22px;
  background: #e2e8f0;
  margin: 0 6px;
  flex-shrink: 0;
}
.zoom-display {
  font-size: 11px;
  font-weight: 600;
  color: #555;
  min-width: 34px;
  text-align: center;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

/* ── Annotations slide panel ── */
.annotations-sidebar-tab {
  position: fixed;
  right: 0;
  top: 35%;
  transform: translateY(-50%);
  z-index: 1100;
  width: 26px;
  height: 56px;
  background: white;
  border: 1px solid #ddd;
  border-right: none;
  border-radius: 8px 0 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: -2px 0 8px rgba(0,0,0,0.08);
  transition: box-shadow 0.2s;
  color: #555;
}
.annotations-sidebar-tab:hover {
  box-shadow: -3px 0 12px rgba(0,0,0,0.14);
  color: #007aff;
}

.annotations-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  width: min(320px, 90vw);
  height: 100vh;
  background: white;
  border-left: 1px solid #ddd;
  box-shadow: -4px 0 24px rgba(0,0,0,0.12);
  z-index: 1100;
  transform: translateX(100%);
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}
.annotations-sidebar.open {
  transform: translateX(0);
}

.annotations-sidebar-header {
  padding: 9px 16px;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fafafa;
  flex-shrink: 0;
}
.annotations-sidebar-header span:first-child {
  flex: 1 1;
}

.annotations-sidebar-body {
  overflow-y: auto;
  flex: 1 1;
}

.workspace-tab-count {
  min-width: 20px;
  height: 20px;
  border-radius: 999px;
  background: rgba(26, 115, 232, 0.14);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  padding: 0 6px;
  margin-left: 6px;
  color: #174ea6;
}

.workspace-tab-item.active .workspace-tab-count {
  background: rgba(26, 115, 232, 0.18);
}

.documentation-panel {
  display: flex;
  flex: 1 1;
  min-height: 0;
  flex-direction: column;
  background:
    radial-gradient(circle at top left, rgba(26, 115, 232, 0.06), transparent 24%),
    linear-gradient(180deg, #f9fbff 0%, #f2f6fc 100%);
}

.documentation-body {
  flex: 1 1;
  min-height: 0;
  padding: 8px 10px 0;
}

.documentation-editor-shell {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.documentation-editor-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.documentation-editor-toolbar-group {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding-right: 6px;
  margin-right: 0;
  border-right: 1px solid rgba(148, 163, 184, 0.2);
}

.documentation-editor-toolbar-group:last-child {
  border-right: none;
  padding-right: 0;
}

.documentation-toolbar-button,
.documentation-toolbar-select {
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: #fff;
  color: #35445c;
  border-radius: 8px;
  min-height: 30px;
  padding: 5px 8px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.documentation-toolbar-button {
  min-width: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.documentation-toolbar-icon {
  font-size: 12px;
  line-height: 1;
}

.documentation-toolbar-addon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  border-radius: 8px;
  background: #fff;
  color: #35445c;
}

.documentation-toolbar-button:hover,
.documentation-toolbar-select:hover {
  border-color: rgba(26, 115, 232, 0.35);
  color: #174ea6;
}

.documentation-toolbar-button.active {
  background: rgba(26, 115, 232, 0.12);
  color: #174ea6;
  border-color: rgba(26, 115, 232, 0.28);
}

.documentation-toolbar-button-listening {
  background: rgba(220, 38, 38, 0.1) !important;
  color: #b91c1c !important;
  border-color: rgba(220, 38, 38, 0.25) !important;
}

.documentation-toolbar-size-control {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.documentation-toolbar-button-small {
  min-width: 28px;
  padding: 5px 6px;
}

.documentation-toolbar-select-compact {
  min-width: 54px;
}

.documentation-toolbar-select-font {
  width: 88px;
}

.documentation-toolbar-select-language {
  width: 98px;
}

.documentation-color-control {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 30px;
  padding: 4px 6px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: #fff;
  color: #35445c;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.documentation-color-control input {
  width: 18px;
  height: 18px;
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
}

.documentation-toolbar-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.documentation-editor-toolbar-group-status {
  border-right: none;
  margin-left: auto;
  padding-right: 0;
}

.documentation-speech-status {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 4px;
  font-size: 11px;
  font-weight: 600;
  color: #2563eb;
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.documentation-speech-status.error {
  color: #b91c1c;
}

.documentation-editor-inner {
  position: relative;
  flex: 1 1;
  min-height: 0;
}

.documentation-editor-content {
  height: 100%;
  min-height: 420px;
  padding: 26px 28px;
  overflow-y: auto;
  outline: none;
  color: #1f2937;
  font-size: 16px;
  line-height: 1.7;
}

.documentation-editor-placeholder {
  position: absolute;
  top: 26px;
  left: 28px;
  color: #94a3b8;
  font-size: 16px;
  pointer-events: none;
}

.documentation-editor-paragraph {
  margin: 0 0 14px;
}

.documentation-editor-h1,
.documentation-editor-h2,
.documentation-editor-h3 {
  color: #132238;
  margin: 0 0 14px;
  font-weight: 700;
}

.documentation-editor-h1 {
  font-size: 2rem;
}

.documentation-editor-h2 {
  font-size: 1.6rem;
}

.documentation-editor-h3 {
  font-size: 1.3rem;
}

.documentation-editor-quote {
  margin: 0 0 14px;
  padding: 10px 16px;
  border-left: 4px solid #1a73e8;
  background: rgba(26, 115, 232, 0.08);
  color: #3d4d64;
  border-radius: 0 12px 12px 0;
}

.documentation-editor-ul,
.documentation-editor-ol {
  margin: 0 0 16px 22px;
  padding: 0;
}

.documentation-editor-li {
  margin: 0 0 8px;
}

.documentation-editor-link {
  color: #1a73e8;
  text-decoration: none;
  border-bottom: 1px solid rgba(26, 115, 232, 0.28);
}

.documentation-editor-inline-code {
  background: rgba(15, 23, 42, 0.08);
  border-radius: 6px;
  padding: 1px 5px;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 0.92em;
}

.documentation-editor-code-block {
  display: block;
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 14px;
  padding: 18px 20px;
  margin: 0 0 16px;
  white-space: pre-wrap;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 14px;
}

.documentation-editor-text-bold {
  font-weight: 700;
}

.documentation-editor-text-italic {
  font-style: italic;
}

.documentation-editor-text-underline {
  text-decoration: underline;
}

.documentation-editor-text-strikethrough {
  text-decoration: line-through;
}

.document-tabs-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px 6px;
  background: rgba(244, 247, 252, 0.9);
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
}

.document-tabs-scroll {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow-x: auto;
  flex: 1 1;
  min-width: 0;
  scrollbar-width: none;
}

.document-tabs-scroll::-webkit-scrollbar {
  display: none;
}

.document-tab-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  padding: 2px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 10px;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.05);
}

.document-tab-item.active {
  border-color: rgba(26, 115, 232, 0.35);
  background: #ffffff;
}

.document-tab-button,
.document-tab-close,
.document-tab-add {
  border: none;
  background: transparent;
  cursor: pointer;
}

.document-tab-button {
  color: #3f4f67;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 9px;
  border-radius: 8px;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.document-tab-item.active .document-tab-button {
  color: #174ea6;
}

.document-tab-close {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  color: #7c8aa3;
  font-size: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.document-tab-close:hover,
.document-tab-add:hover {
  background: rgba(26, 115, 232, 0.1);
  color: #174ea6;
}

.document-tab-add {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  color: #174ea6;
  font-size: 16px;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.9);
  border: 1px dashed rgba(26, 115, 232, 0.32);
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.document-tab-input {
  border: none;
  outline: none;
  background: transparent;
  color: #132238;
  font-size: 13px;
  font-weight: 600;
  min-width: 140px;
  padding: 6px 9px;
}

.workspace-rich-text {
  color: #1f2937;
}

.workspace-rich-text h1,
.workspace-rich-text h2,
.workspace-rich-text h3 {
  margin: 0 0 12px;
  color: #0f172a;
  font-weight: 700;
  line-height: 1.25;
}

.workspace-rich-text h1 {
  font-size: 24px;
  letter-spacing: -0.02em;
}

.workspace-rich-text h2 {
  font-size: 18px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.3);
}

.workspace-rich-text h3 {
  font-size: 15px;
}

.workspace-rich-text p {
  margin: 0 0 10px;
}

.workspace-rich-text ul,
.workspace-rich-text ol {
  margin: 0 0 14px;
  padding-left: 22px;
}

.workspace-rich-text li {
  margin: 0 0 8px;
}

.workspace-rich-text strong {
  color: #0f172a;
  font-weight: 700;
}

.workspace-rich-text hr {
  border: none;
  border-top: 1px solid rgba(148, 163, 184, 0.35);
  margin: 18px 0;
}

/* Summary modal overrides */
.summary-body .workspace-rich-text h1 { font-size: 17px; margin-bottom: 6px; }
.summary-body .workspace-rich-text h2 { font-size: 15px; margin-bottom: 5px; padding-bottom: 3px; }
.summary-body .workspace-rich-text h3 { font-size: 14px; margin-bottom: 4px; }
.summary-body .workspace-rich-text p  { margin-bottom: 5px; }
.summary-body .workspace-rich-text ul,
.summary-body .workspace-rich-text ol { margin-bottom: 8px; }
.summary-body .workspace-rich-text li { margin-bottom: 3px; }
.summary-body .workspace-rich-text,
.summary-body .workspace-rich-text * { font-family: "Times New Roman", Times, serif; }

@media (max-width: 900px) {
  .documentation-body {
    padding: 8px 8px 0;
  }

  .documentation-editor-content {
    padding: 20px 18px;
  }

  .documentation-editor-placeholder {
    left: 18px;
    top: 20px;
  }
}


.main-navbar {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.navbar-left {
  display: flex;
  align-items: center;
  min-width: 220px;
  padding-left: 0;
}

.navbar-center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  overflow: visible;
}

.navbar-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-width: fit-content;
  padding-right: 0;
}

.navbar-right > * {
  flex-shrink: 0;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 8px;
  width: clamp(180px, 22vw, 300px);
  min-width: 0;
}

.search-container input {
  min-width: 0;
  width: 100%;
}

.tool-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px;
  min-width: 0;
}

.tool-btn {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.zoom-display {
  min-width: 30px;
  font-size: 11px;
  text-align: center;
}

.navbar-section-divider {
  width: 1px;
  height: 20px;
  margin: 0 4px;
  flex-shrink: 0;
}

/* iPad landscape (1025-1280px): keep every tool on ONE row by giving the search
   box less room, instead of hiding tools. Only the narrowest widths drop the
   three least-used tools. */
@media (max-width: 1280px) {
  .search-container {
    width: clamp(150px, 16vw, 210px);
  }
  .main-navbar {
    gap: 6px;
  }
}

@media (max-width: 1060px) {
  .tool-btn[title="PDF Thumbnails"],
  .tool-btn[title="Summarize PDF"],
  .tool-btn[title="All Annotations"] {
    display: none;
  }
}

@media (max-width: 1180px) {
  .tool-group {
    gap: 4px;
  }

  .tool-btn {
    width: 30px;
    height: 30px;
  }

  .navbar-section-divider {
    display: none;
  }
}

/* ── Tablet / iPad portrait (≤1024px): one-line top bar + bottom tool dock ──
   Search, bookmarks and Save stay on a single top row. The drawing/annotation
   tools (.navbar-center) move into a floating dock at the bottom of the screen,
   the same pattern iPad note apps use. The app column reserves room for the dock
   (.app-container.has-toolbar padding) so panel-anchored controls — PDF zoom pill,
   workspace zoom, PDF/Split/Notes toggle — sit above it instead of under it. */
@media (max-width: 1024px) {
  :root {
    --tool-dock-space: 68px;
  }

  .app-container.has-toolbar {
    padding-bottom: calc(var(--tool-dock-space) + env(safe-area-inset-bottom, 0px));
    box-sizing: border-box;
  }

  /* backdrop-filter would make the navbar the containing block for the fixed
     dock (pinning it inside the top bar), so use a solid background here. */
  .main-navbar {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 6px 12px;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    background: rgba(255, 255, 255, 0.98);
  }

  /* Search takes whatever is left after the right-side buttons, and shrinks
     instead of running into them */
  .navbar-left {
    flex: 1 1;
    min-width: 0;
  }
  .navbar-left .search-wrapper {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 340px;
  }
  .navbar-left .search-container {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }
  .navbar-right {
    flex: 0 0 auto;
    gap: 4px;
  }

  /* The dock */
  .navbar-center {
    position: fixed;
    left: 50%;
    bottom: calc(10px + env(safe-area-inset-bottom, 0px));
    transform: translateX(-50%);
    z-index: 1002;
    width: max-content;
    max-width: calc(100vw - 20px);
    flex-wrap: nowrap;
    justify-content: center;
    gap: 2px;
    padding: 5px 8px;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 16px;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.16), 0 2px 6px rgba(0, 0, 0, 0.06);
    box-sizing: border-box;
  }
  .navbar-center .tool-group {
    flex-wrap: nowrap;
    gap: 2px;
  }

  /* Colour / page menus open UPWARD out of the dock instead of off-screen */
  .navbar-center .tool-popover {
    top: auto !important;
    bottom: calc(100% + 10px) !important;
    margin-top: 0 !important;
  }

  /* Side panels end above the dock instead of covering half of it */
  .annotations-sidebar {
    height: auto;
    bottom: calc(var(--tool-dock-space) + env(safe-area-inset-bottom, 0px));
  }
  .bookmarks-sidebar {
    height: auto !important;
    bottom: calc(var(--tool-dock-space) + env(safe-area-inset-bottom, 0px));
  }

  /* Toasts float above the dock */
  .toast-stack {
    bottom: calc(var(--tool-dock-space) + 16px + env(safe-area-inset-bottom, 0px)) !important;
  }

  /* There's room in the dock for every tool */
  .tool-btn[title="PDF Thumbnails"],
  .tool-btn[title="Summarize PDF"],
  .tool-btn[title="All Annotations"] {
    display: flex;
  }

  /* Comfortable touch targets for fingers */
  .tool-btn {
    width: 38px;
    height: 38px;
  }
}

/* Very narrow (small iPad split-view / phones): slightly tighter dock buttons */
@media (max-width: 600px) {
  .navbar-center .tool-btn {
    width: 34px;
    height: 34px;
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Home button (navbar, left of search) — back to the user's start page */
.navbar-home-btn {
  width: 34px;
  height: 34px;
  margin-right: 8px;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 9px;
  background: rgba(240, 242, 245, 0.9);
  color: #3c4043;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.navbar-home-btn:hover:not(:disabled) {
  background: #e8f0fe;
  color: #1a73e8;
}
.navbar-home-btn:disabled {
  cursor: progress;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc,EAAE,4DAA4D;EAC5E,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,+CAA+C;EAC/C,UAAU;EACV,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,0BAA0B;EAC1B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qFAAqF;AACvF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8EAA8E;EAC9E,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;AACf;;;AAGA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;0EAC0E;AAC1E;EACE,WAAW;EACX,YAAY;AACd;AACA,8EAA8E;AAC9E;EACE,qBAAqB;AACvB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,yEAAyE;EACzE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,mFAAmF;AACnF;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,wCAAwC;EACxC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,qFAAqF;EACrF,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mFAAmF;EACnF,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,uDAAuD;EACzD;;EAEA;IACE,UAAU;IACV,kDAAkD;EACpD;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,eAAe;EACf,kEAAkE;EAClE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;;EAEE;;AAEF,6BAA6B;AAC7B,6BAA6B;AAC7B;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,wGAAwG;EACxG,oBAAoB;EACpB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB;iGAC+F;EAC/F,0BAA0B;EAC1B,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,wBAAwB;EACxB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,mCAAmC;EACnC,gCAAgC;EAChC,yCAAyC;EACzC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kHAAkH;EAClH,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB;;4DAE0D;EAC1D,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,UAAU;EACV,yCAAyC;EACzC,sBAAsB;EACtB,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,iBAAiB,EAAE,6EAA6E;EAChG,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E,2CAA2C;AAC3C;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uCAAuC;EACvC,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,wCAAwC;EACxC,aAAa;EACb,2BAA2B;EAC3B,wDAAwD;EACxD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8EAA8E;AAChF;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB;;qDAEmD;AACrD;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,kDAAkD;EAClD,6DAA6D;AAC/D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;EACpC,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,4EAA4E;EAC5E,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,4EAA4E;EAC5E,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,oCAAoC;EACpC,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,2CAA2C;EAC3C,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,cAAc;AAChB;;AAEA,4BAA4B;AAC5B,wCAAwC,eAAe,EAAE,kBAAkB,EAAE;AAC7E,wCAAwC,eAAe,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAClG,wCAAwC,eAAe,EAAE,kBAAkB,EAAE;AAC7E,wCAAwC,kBAAkB,EAAE;AAC5D;wCACwC,kBAAkB,EAAE;AAC5D,wCAAwC,kBAAkB,EAAE;AAC5D;uCACuC,4CAA4C,EAAE;;AAErF;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;AACF;;;AAGA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;EAC3C,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;;4BAE4B;AAC5B;EACE;IACE,gCAAgC;EAClC;EACA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;;;IAGE,aAAa;EACf;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;;;;+EAK+E;AAC/E;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,+EAA+E;IAC/E,sBAAsB;EACxB;;EAEA;4EAC0E;EAC1E;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,iBAAiB;IACjB,qBAAqB;IACrB,6BAA6B;IAC7B,qCAAqC;EACvC;;EAEA;mCACiC;EACjC;IACE,SAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,QAAQ;EACV;;EAEA,aAAa;EACb;IACE,eAAe;IACf,SAAS;IACT,qDAAqD;IACrD,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;IACnB,yEAAyE;IACzE,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA,0EAA0E;EAC1E;IACE,oBAAoB;IACpB,oCAAoC;IACpC,wBAAwB;EAC1B;;EAEA,kEAAkE;EAClE;IACE,YAAY;IACZ,uEAAuE;EACzE;EACA;IACE,uBAAuB;IACvB,uEAAuE;EACzE;;EAEA,gCAAgC;EAChC;IACE,yFAAyF;EAC3F;;EAEA,4CAA4C;EAC5C;;;IAGE,aAAa;EACf;;EAEA,0CAA0C;EAC1C;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".app-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n  height: 100dvh; /* iPad Safari: the visible height, excluding browser bars */\r\n  width: 100%;\r\n  overflow: hidden;\r\n  background-color: #FAF9F6;\r\n}\r\n\r\n.main-navbar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  height: 56px;\r\n  background: rgba(255, 255, 255, 0.7);\r\n  backdrop-filter: blur(16px);\r\n  -webkit-backdrop-filter: blur(16px);\r\n  border-bottom: 1px solid rgba(30, 41, 59, 0.08);\r\n  padding: 0;\r\n  /* Align with content boundary */\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1000;\r\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.navbar-left {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  padding-left: 20px;\r\n}\r\n\r\n.navbar-center {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.navbar-right {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 15px;\r\n  padding-right: 20px;\r\n}\r\n\r\n.nav-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 14px;\r\n  background: rgba(255, 255, 255, 0.6);\r\n  backdrop-filter: blur(8px);\r\n  border: 1px solid rgba(30, 41, 59, 0.1);\r\n  border-radius: 14px;\r\n  font-size: 13px;\r\n  color: #1E293B;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.nav-label {\r\n  opacity: 0.6;\r\n  font-size: 10px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.8px;\r\n  font-weight: 800;\r\n}\r\n\r\n.nav-name-container {\r\n  max-width: 150px;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  position: relative;\r\n  mask-image: linear-gradient(to right, transparent, black 15%, black 85%, transparent);\r\n}\r\n\r\n.nav-info-text {\r\n  display: inline-block;\r\n  padding-left: 10px;\r\n  color: #1a73e8;\r\n  white-space: nowrap;\r\n}\r\n\r\n.nav-info-text.animate {\r\n  animation: marquee-text 10s linear infinite;\r\n}\r\n\r\n@keyframes marquee-text {\r\n  0% {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  100% {\r\n    transform: translateX(-100%);\r\n  }\r\n}\r\n\r\n.search-wrapper {\r\n  position: relative;\r\n}\r\n\r\n.search-suggestion {\r\n  position: absolute;\r\n  top: calc(100% + 6px);\r\n  left: 0;\r\n  z-index: 60;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  padding: 7px 12px;\r\n  background: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\r\n  font-size: 13px;\r\n  color: #64748b;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.search-suggestion:hover {\r\n  border-color: #3b82f6;\r\n  background: #f8fafc;\r\n}\r\n\r\n.search-suggestion strong {\r\n  color: #1e293b;\r\n  font-weight: 600;\r\n}\r\n\r\n.search-suggestion-count {\r\n  margin-left: auto;\r\n  flex-shrink: 0;\r\n  font-size: 11px;\r\n  color: #94a3b8;\r\n}\r\n\r\n.search-container {\r\n  display: flex;\r\n  align-items: center;\r\n  background: rgba(255, 255, 255, 0.8);\r\n  border: 1px solid rgba(30, 41, 59, 0.1);\r\n  border-radius: 12px;\r\n  padding: 6px 14px;\r\n  gap: 8px;\r\n  width: 300px;\r\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow: inset 0 2px 4px rgba(0,0,0,0.01);\r\n}\r\n\r\n.search-container:focus-within {\r\n  background: #ffffff;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15), 0 4px 12px rgba(0, 0, 0, 0.05);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.search-icon {\r\n  color: #94a3b8;\r\n  display: flex;\r\n}\r\n\r\n.search-container input {\r\n  border: none;\r\n  outline: none;\r\n  font-size: 14px;\r\n  width: 100%;\r\n  color: #1e293b;\r\n}\r\n\r\n.search-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  border-left: 1px solid #e2e8f0;\r\n  padding-left: 8px;\r\n}\r\n\r\n.match-count {\r\n  font-size: 12px;\r\n  color: #64748b;\r\n  margin-right: 4px;\r\n}\r\n\r\n.search-controls button {\r\n  background: none;\r\n  border: none;\r\n  padding: 4px;\r\n  cursor: pointer;\r\n  color: #64748b;\r\n  display: flex;\r\n  border-radius: 4px;\r\n}\r\n\r\n.search-controls button:hover:not(:disabled) {\r\n  background: #f1f5f9;\r\n  color: #1e293b;\r\n}\r\n\r\n.tool-group {\r\n  display: flex;\r\n  background: transparent;\r\n  padding: 4px;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.tool-btn {\r\n  background: none;\r\n  border: none;\r\n  color: #5c6b89;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: relative;\r\n}\r\n\r\n.tool-btn:hover {\r\n  background: rgba(0, 0, 0, 0.03);\r\n  color: #1e293b;\r\n}\r\n\r\n.tool-btn.active {\r\n  background: #1E293B;\r\n  color: #fff;\r\n  box-shadow: 0 4px 12px rgba(30, 41, 59, 0.3);\r\n}\r\n\r\n.tool-btn.active::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  border-radius: 50%;\r\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.save-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: #1E293B;\r\n  color: white;\r\n  border: none;\r\n  padding: 8px 18px;\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow: 0 2px 8px rgba(30, 41, 59, 0.2);\r\n}\r\n\r\n.save-btn:hover:not(:disabled) {\r\n  background: #0f172a;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(30, 41, 59, 0.3);\r\n}\r\n\r\n.save-btn:disabled {\r\n  background: #9ca3af;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.save-btn.saving {\r\n  opacity: 0.8;\r\n}\r\n\r\n.main-content {\r\n  display: flex;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  contain: layout style;\r\n}\r\n\r\n.app-empty-state {\r\n  display: flex;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n\r\n.pdf-view-container {\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  background: #FAF9F6;\r\n  will-change: width;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.pdf-view-container:not(.is-resizing) {\r\n  transition: width 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n}\r\n\r\n.pdf-viewer-outer-wrapper {\r\n  height: 100% !important;\r\n}\r\n\r\n.pdf-viewer-container {\r\n  overflow-x: auto;\r\n  overflow-y: auto !important;\r\n  scroll-behavior: auto;\r\n}\r\n\r\n/* Custom scrollbar — fixed width so markers overlay it precisely.\r\n   Widened 12px -> 16px; keep SCROLLBAR_W in PDFScrollMarker.js in sync. */\r\n.pdf-viewer-container::-webkit-scrollbar {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n/* Firefox has no ::-webkit-scrollbar; \"auto\" is its wider (non-thin) track. */\r\n.pdf-viewer-container {\r\n  scrollbar-width: auto;\r\n}\r\n.pdf-viewer-container::-webkit-scrollbar-track {\r\n  background: rgba(0, 0, 0, 0.06);\r\n}\r\n.pdf-viewer-container::-webkit-scrollbar-thumb {\r\n  background: rgba(0, 0, 0, 0.28);\r\n  border-radius: 7px;\r\n  border: 2px solid transparent;\r\n  background-clip: padding-box;\r\n}\r\n.pdf-viewer-container::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(0, 0, 0, 0.45);\r\n  border: 2px solid transparent;\r\n  background-clip: padding-box;\r\n}\r\n\r\n.layout-resizer {\r\n  width: 6px;\r\n  background: #E2E8F0;\r\n  cursor: col-resize;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 100;\r\n  transition: background 0.2s;\r\n  user-select: none;\r\n  will-change: background;\r\n  /* iPad: without this Safari treats the drag as a scroll and cancels it */\r\n  touch-action: none;\r\n  -webkit-user-select: none;\r\n}\r\n\r\n/* Invisible wider grab area — the visible bar is only 6px, too thin for a finger */\r\n.layout-resizer::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: -10px;\r\n  right: -10px;\r\n}\r\n\r\n.layout-resizer:hover,\r\n.layout-resizer.active {\r\n  background: #94A3B8;\r\n}\r\n\r\n.resizer-handle {\r\n  width: 24px;\r\n  height: 48px;\r\n  background: #ffffff;\r\n  border: 1px solid #CBD5E1;\r\n  border-radius: 6px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  pointer-events: none;\r\n  /* Let clicks pass to parent container */\r\n  user-select: none;\r\n}\r\n\r\n.layout-resizer:hover .resizer-handle,\r\n.layout-resizer.active .resizer-handle {\r\n  border-color: #94A3B8;\r\n  color: #475569;\r\n}\r\n\r\n.workspace-view-wrapper {\r\n  flex: 1;\r\n  min-width: 0;\r\n  min-height: 0;\r\n  position: relative;\r\n  overflow: hidden;\r\n  will-change: width;\r\n}\r\n\r\n.workspace-view-container {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  background: #F4F5F7;\r\n  overflow: hidden;\r\n  user-select: none;\r\n  touch-action: none;\r\n}\r\n\r\n/* Page Jump Modal Styles */\r\n.page-jump-modal {\r\n  background: white;\r\n  width: 320px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\r\n  overflow: hidden;\r\n  animation: modalAppear 0.3s ease-out;\r\n}\r\n\r\n.page-jump-header {\r\n  padding: 16px 20px;\r\n  border-bottom: 1px solid #eee;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: #fff;\r\n}\r\n\r\n.page-jump-header h3 {\r\n  margin: 0;\r\n  font-size: 1.1rem;\r\n  color: #1a202c;\r\n  font-weight: 600;\r\n}\r\n\r\n.page-jump-body {\r\n  padding: 24px 20px;\r\n  text-align: center;\r\n}\r\n\r\n.page-jump-info {\r\n  font-size: 14px;\r\n  color: #64748b;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.page-jump-input-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.page-jump-input-group input {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  outline: none;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.page-jump-input-group input:focus {\r\n  border-color: #1a73e8;\r\n}\r\n\r\n.page-jump-go-btn {\r\n  background: #1a73e8;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.page-jump-go-btn:hover {\r\n  background: #1557b0;\r\n}\r\n\r\n\r\n/* PDF Thumbnail Styles */\r\n.pdf-thumbnail-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 2000;\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.pdf-thumbnail-modal {\r\n  background: white;\r\n  width: 90%;\r\n  max-width: 1000px;\r\n  max-height: 85vh;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n  overflow: hidden;\r\n  animation: modalAppear 0.3s ease-out;\r\n}\r\n\r\n@keyframes modalAppear {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.95);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.pdf-thumbnail-header {\r\n  padding: 16px 24px;\r\n  border-bottom: 1px solid #eee;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: #fff;\r\n}\r\n\r\n.pdf-thumbnail-header h3 {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n  color: #1a202c;\r\n  font-weight: 600;\r\n}\r\n\r\n.pdf-thumbnail-header .close-btn {\r\n  background: #f7fafc;\r\n  border: none;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  color: #718096;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.pdf-thumbnail-header .close-btn:hover {\r\n  background: #edf2f7;\r\n  color: #1a202c;\r\n}\r\n\r\n.pdf-thumbnail-grid {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 24px;\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 24px;\r\n  background: #f7fafc;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .pdf-thumbnail-grid {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .pdf-thumbnail-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n.thumbnail-item-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.thumbnail-container {\r\n  width: 100%;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  position: relative;\r\n}\r\n\r\n.thumbnail-box {\r\n  width: 100%;\r\n  aspect-ratio: 0.75;\r\n  background: white;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.thumbnail-container:hover .thumbnail-box {\r\n  border-color: #4a90e2;\r\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.thumbnail-box canvas {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.thumbnail-placeholder {\r\n  font-size: 12px;\r\n  color: #a0aec0;\r\n  text-align: center;\r\n  padding: 10px;\r\n}\r\n\r\n.thumbnail-label {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #4a5568;\r\n}\r\n\r\n/* Selection Popup Styles */\r\n.selection-popup {\r\n  background: rgba(255, 255, 255, 0.95);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\r\n  border-radius: 20px;\r\n  padding: 6px 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  position: absolute;\r\n  transform: translateX(-50%);\r\n  z-index: 10000;\r\n  animation: popupFadeIn 0.2s ease-out;\r\n}\r\n\r\n@keyframes popupFadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-50%) translateY(10px) scale(0.9);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(-50%) translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n.color-btn {\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 50%;\r\n  border: 2px solid white;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n  cursor: pointer;\r\n  transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n  padding: 0;\r\n}\r\n\r\n.color-btn:hover {\r\n  transform: scale(1.2);\r\n}\r\n\r\n.color-btn.none-btn {\r\n  background: #eee;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 1;\r\n  font-size: 16px;\r\n  color: #666;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Divider Line Between PDF and Workspace */\r\n/*.pdf-view-container {\r\n  border-right: 2px solid #000;\r\n}*/\r\n\r\n/* Session Highlight Styles */\r\n/* Draggable PDF Tool Panel */\r\n.draggable-pdf-panel {\r\n  transition: border-color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.draggable-pdf-panel:hover {\r\n  border-color: #bbb;\r\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.panel-btn {\r\n  width: 36px;\r\n  height: 36px;\r\n  display: flex !important;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease !important;\r\n}\r\n\r\n.panel-btn:hover {\r\n  background: rgba(0, 0, 0, 0.05) !important;\r\n  color: #1a73e8 !important;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.panel-btn.active {\r\n  background: #e8f0fe !important;\r\n  color: #1a73e8 !important;\r\n  box-shadow: inset 0 0 0 1px rgba(26, 115, 232, 0.2);\r\n}\r\n\r\n.drag-handle {\r\n  opacity: 0.5;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.draggable-pdf-panel:hover .drag-handle {\r\n  opacity: 1;\r\n}\r\n\r\n.vertical-color-picker {\r\n  animation: slideInRight 0.2s ease-out;\r\n}\r\n\r\n@keyframes slideInRight {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n/* Intra-page Collapsing (Slicing) Styles */\r\n.shredded-page {\r\n  position: relative;\r\n  overflow: visible !important;\r\n}\r\n\r\n.pdf-page-slice {\r\n  position: absolute;\r\n  left: 0;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  transition: transform 0.36s cubic-bezier(.22, .9, .32, 1), clip-path 0.36s cubic-bezier(.22, .9, .32, 1);\r\n  pointer-events: auto;\r\n  background: white;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.pdf-page-slice canvas,\r\n.pdf-page-slice .textLayer {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.jagged-divider {\r\n  position: absolute;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 20px;\r\n  z-index: 10;\r\n  pointer-events: none;\r\n  background-image: linear-gradient(45deg, transparent 33.333%, #ddd 33.333%, #ddd 66.666%, transparent 66.666%),\r\n    linear-gradient(-45deg, transparent 33.333%, #ddd 33.333%, #ddd 66.666%, transparent 66.666%);\r\n  background-size: 15px 30px;\r\n  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.05));\r\n  opacity: 0.8;\r\n}\r\n\r\n.fold-indicator {\r\n  position: absolute;\r\n  right: -30px;\r\n  width: 25px;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  opacity: 0.5;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.shredded-page:hover .fold-indicator {\r\n  opacity: 1;\r\n}\r\n\r\n.pdf-session-highlight {\r\n  pointer-events: none;\r\n  z-index: 4;\r\n  mix-blend-mode: multiply;\r\n  transition: background-color 0.2s ease;\r\n  border-radius: 2px;\r\n}\r\n\r\n.workspace-container {\r\n  touch-action: none;\r\n}\r\n\r\n/* Context Bar Styles (New Bottom Navbar) */\r\n.context-bar {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 36px;\r\n  /* Slim professional bar */\r\n  background: #f1f3f4;\r\n  /* Light grey standard toolbar bg */\r\n  border-bottom: 1px solid #dadce0;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n  z-index: 900;\r\n  overflow: visible;\r\n}\r\n\r\n.context-value {\r\n  font-size: 13px;\r\n}\r\n\r\n.context-tab.pdf-tab {\r\n  /* This class might be deprecated if we switch structure, but keeping for safety/legacy naming if used elsewhere */\r\n  display: flex;\r\n}\r\n\r\n.pdf-tabs-container {\r\n  flex: 0 0 auto;\r\n  /* Width set inline */\r\n  display: flex;\r\n  align-items: center;\r\n  /* clip horizontally so the \"Files:\" label and tabs can't bleed onto the\r\n     workspace tabs when the PDF panel is collapsed/narrow; y stays visible\r\n     so the overflow dropdown can still open below the bar */\r\n  overflow-x: clip;\r\n  overflow-y: visible;\r\n  background: #ffffff;\r\n  border-right: 1px solid #dadce0;\r\n  z-index: 2;\r\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);\r\n  transition: width 0.1s;\r\n  padding-left: 0;\r\n}\r\n\r\n/* Reuse workspace-tab-item but ensure it displays correctly in PDF container */\r\n.pdf-tab-active {\r\n  margin-top: 8px;\r\n  /* Alignment */\r\n}\r\n\r\n.workspace-tabs-container {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  overflow: visible; /* must NOT be hidden — inner .workspace-tabs-scroll needs overflow-x: auto */\r\n  background: #ffffff;\r\n}\r\n\r\n.workspace-tabs-scroll {\r\n  display: flex;\r\n  align-items: center;\r\n  scrollbar-width: thin;\r\n  /* Firefox */\r\n  scrollbar-color: #ccc #f1f1f1;\r\n}\r\n\r\n.workspace-tabs-scroll::-webkit-scrollbar {\r\n  height: 4px;\r\n}\r\n\r\n.workspace-tabs-scroll::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n.workspace-tabs-scroll::-webkit-scrollbar-thumb {\r\n  background: #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n.workspace-tabs-scroll::-webkit-scrollbar-thumb:hover {\r\n  background: #aaa;\r\n}\r\n\r\n.workspace-tab-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 16px;\r\n  height: 32px;\r\n  /* Inner tab height */\r\n  margin-right: 6px;\r\n  border-radius: 8px 8px 0 0;\r\n  /* Tab look */\r\n  background: #dfe1e5;\r\n  color: #5f6368;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  transition: all 0.2s ease;\r\n  border: 1px solid transparent;\r\n  margin-top: 8px;\r\n  /* Push down to look like tab on bottom border */\r\n  border-bottom: none;\r\n}\r\n\r\n.workspace-tab-item:hover {\r\n  background: #d4d7dc;\r\n}\r\n\r\n.workspace-tab-item.active {\r\n  background: #e8f0fe;\r\n  color: #1a73e8;\r\n  border-top: 2px solid #1a73e8;\r\n  border-left: 1px solid #dadce0;\r\n  border-right: 1px solid #dadce0;\r\n  font-weight: 600;\r\n  box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.add-workspace-btn {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  background: transparent;\r\n  color: #5f6368;\r\n  font-size: 18px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  margin-left: 4px;\r\n}\r\n\r\n.add-workspace-btn:hover {\r\n  background: rgba(0, 0, 0, 0.05);\r\n  color: #1a73e8;\r\n}\r\n\r\n.context-label {\r\n  padding-left: 16px;\r\n  font-weight: 600;\r\n  color: #5f6368;\r\n  margin-right: 8px;\r\n  text-transform: uppercase;\r\n  font-size: 11px;\r\n  letter-spacing: 0.5px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Adjust Main Content to not overlap if needed, but flex column handles it */\r\n/* ── Navbar unified toolbar additions ── */\r\n.navbar-section-divider {\r\n  width: 1px;\r\n  height: 22px;\r\n  background: #e2e8f0;\r\n  margin: 0 6px;\r\n  flex-shrink: 0;\r\n}\r\n.zoom-display {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #555;\r\n  min-width: 34px;\r\n  text-align: center;\r\n  pointer-events: none;\r\n  user-select: none;\r\n}\r\n\r\n/* ── Annotations slide panel ── */\r\n.annotations-sidebar-tab {\r\n  position: fixed;\r\n  right: 0;\r\n  top: 35%;\r\n  transform: translateY(-50%);\r\n  z-index: 1100;\r\n  width: 26px;\r\n  height: 56px;\r\n  background: white;\r\n  border: 1px solid #ddd;\r\n  border-right: none;\r\n  border-radius: 8px 0 0 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  box-shadow: -2px 0 8px rgba(0,0,0,0.08);\r\n  transition: box-shadow 0.2s;\r\n  color: #555;\r\n}\r\n.annotations-sidebar-tab:hover {\r\n  box-shadow: -3px 0 12px rgba(0,0,0,0.14);\r\n  color: #007aff;\r\n}\r\n\r\n.annotations-sidebar {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  width: min(320px, 90vw);\r\n  height: 100vh;\r\n  background: white;\r\n  border-left: 1px solid #ddd;\r\n  box-shadow: -4px 0 24px rgba(0,0,0,0.12);\r\n  z-index: 1100;\r\n  transform: translateX(100%);\r\n  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\r\n}\r\n.annotations-sidebar.open {\r\n  transform: translateX(0);\r\n}\r\n\r\n.annotations-sidebar-header {\r\n  padding: 9px 16px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  border-bottom: 1px solid #eee;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: #fafafa;\r\n  flex-shrink: 0;\r\n}\r\n.annotations-sidebar-header span:first-child {\r\n  flex: 1;\r\n}\r\n\r\n.annotations-sidebar-body {\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.workspace-tab-count {\r\n  min-width: 20px;\r\n  height: 20px;\r\n  border-radius: 999px;\r\n  background: rgba(26, 115, 232, 0.14);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  padding: 0 6px;\r\n  margin-left: 6px;\r\n  color: #174ea6;\r\n}\r\n\r\n.workspace-tab-item.active .workspace-tab-count {\r\n  background: rgba(26, 115, 232, 0.18);\r\n}\r\n\r\n.documentation-panel {\r\n  display: flex;\r\n  flex: 1;\r\n  min-height: 0;\r\n  flex-direction: column;\r\n  background:\r\n    radial-gradient(circle at top left, rgba(26, 115, 232, 0.06), transparent 24%),\r\n    linear-gradient(180deg, #f9fbff 0%, #f2f6fc 100%);\r\n}\r\n\r\n.documentation-body {\r\n  flex: 1;\r\n  min-height: 0;\r\n  padding: 8px 10px 0;\r\n}\r\n\r\n.documentation-editor-shell {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  background: rgba(255, 255, 255, 0.88);\r\n  border: 1px solid rgba(148, 163, 184, 0.25);\r\n  border-radius: 18px;\r\n  overflow: hidden;\r\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.documentation-editor-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  padding: 8px 10px;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.18);\r\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\r\n}\r\n\r\n.documentation-editor-toolbar-group {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding-right: 6px;\r\n  margin-right: 0;\r\n  border-right: 1px solid rgba(148, 163, 184, 0.2);\r\n}\r\n\r\n.documentation-editor-toolbar-group:last-child {\r\n  border-right: none;\r\n  padding-right: 0;\r\n}\r\n\r\n.documentation-toolbar-button,\r\n.documentation-toolbar-select {\r\n  border: 1px solid rgba(148, 163, 184, 0.28);\r\n  background: #fff;\r\n  color: #35445c;\r\n  border-radius: 8px;\r\n  min-height: 30px;\r\n  padding: 5px 8px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;\r\n}\r\n\r\n.documentation-toolbar-button {\r\n  min-width: 30px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.documentation-toolbar-icon {\r\n  font-size: 12px;\r\n  line-height: 1;\r\n}\r\n\r\n.documentation-toolbar-addon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 28px;\r\n  height: 28px;\r\n  border: 1px solid rgba(148, 163, 184, 0.28);\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #35445c;\r\n}\r\n\r\n.documentation-toolbar-button:hover,\r\n.documentation-toolbar-select:hover {\r\n  border-color: rgba(26, 115, 232, 0.35);\r\n  color: #174ea6;\r\n}\r\n\r\n.documentation-toolbar-button.active {\r\n  background: rgba(26, 115, 232, 0.12);\r\n  color: #174ea6;\r\n  border-color: rgba(26, 115, 232, 0.28);\r\n}\r\n\r\n.documentation-toolbar-button-listening {\r\n  background: rgba(220, 38, 38, 0.1) !important;\r\n  color: #b91c1c !important;\r\n  border-color: rgba(220, 38, 38, 0.25) !important;\r\n}\r\n\r\n.documentation-toolbar-size-control {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.documentation-toolbar-button-small {\r\n  min-width: 28px;\r\n  padding: 5px 6px;\r\n}\r\n\r\n.documentation-toolbar-select-compact {\r\n  min-width: 54px;\r\n}\r\n\r\n.documentation-toolbar-select-font {\r\n  width: 88px;\r\n}\r\n\r\n.documentation-toolbar-select-language {\r\n  width: 98px;\r\n}\r\n\r\n.documentation-color-control {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  min-height: 30px;\r\n  padding: 4px 6px;\r\n  border-radius: 8px;\r\n  border: 1px solid rgba(148, 163, 184, 0.28);\r\n  background: #fff;\r\n  color: #35445c;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.documentation-color-control input {\r\n  width: 18px;\r\n  height: 18px;\r\n  border: none;\r\n  padding: 0;\r\n  background: transparent;\r\n  cursor: pointer;\r\n}\r\n\r\n.documentation-toolbar-button:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.documentation-editor-toolbar-group-status {\r\n  border-right: none;\r\n  margin-left: auto;\r\n  padding-right: 0;\r\n}\r\n\r\n.documentation-speech-status {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  min-height: 28px;\r\n  padding: 0 4px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #2563eb;\r\n  max-width: 260px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.documentation-speech-status.error {\r\n  color: #b91c1c;\r\n}\r\n\r\n.documentation-editor-inner {\r\n  position: relative;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.documentation-editor-content {\r\n  height: 100%;\r\n  min-height: 420px;\r\n  padding: 26px 28px;\r\n  overflow-y: auto;\r\n  outline: none;\r\n  color: #1f2937;\r\n  font-size: 16px;\r\n  line-height: 1.7;\r\n}\r\n\r\n.documentation-editor-placeholder {\r\n  position: absolute;\r\n  top: 26px;\r\n  left: 28px;\r\n  color: #94a3b8;\r\n  font-size: 16px;\r\n  pointer-events: none;\r\n}\r\n\r\n.documentation-editor-paragraph {\r\n  margin: 0 0 14px;\r\n}\r\n\r\n.documentation-editor-h1,\r\n.documentation-editor-h2,\r\n.documentation-editor-h3 {\r\n  color: #132238;\r\n  margin: 0 0 14px;\r\n  font-weight: 700;\r\n}\r\n\r\n.documentation-editor-h1 {\r\n  font-size: 2rem;\r\n}\r\n\r\n.documentation-editor-h2 {\r\n  font-size: 1.6rem;\r\n}\r\n\r\n.documentation-editor-h3 {\r\n  font-size: 1.3rem;\r\n}\r\n\r\n.documentation-editor-quote {\r\n  margin: 0 0 14px;\r\n  padding: 10px 16px;\r\n  border-left: 4px solid #1a73e8;\r\n  background: rgba(26, 115, 232, 0.08);\r\n  color: #3d4d64;\r\n  border-radius: 0 12px 12px 0;\r\n}\r\n\r\n.documentation-editor-ul,\r\n.documentation-editor-ol {\r\n  margin: 0 0 16px 22px;\r\n  padding: 0;\r\n}\r\n\r\n.documentation-editor-li {\r\n  margin: 0 0 8px;\r\n}\r\n\r\n.documentation-editor-link {\r\n  color: #1a73e8;\r\n  text-decoration: none;\r\n  border-bottom: 1px solid rgba(26, 115, 232, 0.28);\r\n}\r\n\r\n.documentation-editor-inline-code {\r\n  background: rgba(15, 23, 42, 0.08);\r\n  border-radius: 6px;\r\n  padding: 1px 5px;\r\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\r\n  font-size: 0.92em;\r\n}\r\n\r\n.documentation-editor-code-block {\r\n  display: block;\r\n  background: #0f172a;\r\n  color: #e2e8f0;\r\n  border-radius: 14px;\r\n  padding: 18px 20px;\r\n  margin: 0 0 16px;\r\n  white-space: pre-wrap;\r\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\r\n  font-size: 14px;\r\n}\r\n\r\n.documentation-editor-text-bold {\r\n  font-weight: 700;\r\n}\r\n\r\n.documentation-editor-text-italic {\r\n  font-style: italic;\r\n}\r\n\r\n.documentation-editor-text-underline {\r\n  text-decoration: underline;\r\n}\r\n\r\n.documentation-editor-text-strikethrough {\r\n  text-decoration: line-through;\r\n}\r\n\r\n.document-tabs-footer {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 10px 6px;\r\n  background: rgba(244, 247, 252, 0.9);\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.18);\r\n}\r\n\r\n.document-tabs-scroll {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  overflow-x: auto;\r\n  flex: 1;\r\n  min-width: 0;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.document-tabs-scroll::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.document-tab-item {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  min-width: 0;\r\n  padding: 2px;\r\n  background: rgba(255, 255, 255, 0.86);\r\n  border: 1px solid rgba(148, 163, 184, 0.24);\r\n  border-radius: 10px;\r\n  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.05);\r\n}\r\n\r\n.document-tab-item.active {\r\n  border-color: rgba(26, 115, 232, 0.35);\r\n  background: #ffffff;\r\n}\r\n\r\n.document-tab-button,\r\n.document-tab-close,\r\n.document-tab-add {\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n}\r\n\r\n.document-tab-button {\r\n  color: #3f4f67;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  padding: 6px 9px;\r\n  border-radius: 8px;\r\n  max-width: 220px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.document-tab-item.active .document-tab-button {\r\n  color: #174ea6;\r\n}\r\n\r\n.document-tab-close {\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 7px;\r\n  color: #7c8aa3;\r\n  font-size: 15px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.document-tab-close:hover,\r\n.document-tab-add:hover {\r\n  background: rgba(26, 115, 232, 0.1);\r\n  color: #174ea6;\r\n}\r\n\r\n.document-tab-add {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 10px;\r\n  color: #174ea6;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  border: 1px dashed rgba(26, 115, 232, 0.32);\r\n  flex-shrink: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.document-tab-input {\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  color: #132238;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  min-width: 140px;\r\n  padding: 6px 9px;\r\n}\r\n\r\n.workspace-rich-text {\r\n  color: #1f2937;\r\n}\r\n\r\n.workspace-rich-text h1,\r\n.workspace-rich-text h2,\r\n.workspace-rich-text h3 {\r\n  margin: 0 0 12px;\r\n  color: #0f172a;\r\n  font-weight: 700;\r\n  line-height: 1.25;\r\n}\r\n\r\n.workspace-rich-text h1 {\r\n  font-size: 24px;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.workspace-rich-text h2 {\r\n  font-size: 18px;\r\n  padding-bottom: 6px;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.3);\r\n}\r\n\r\n.workspace-rich-text h3 {\r\n  font-size: 15px;\r\n}\r\n\r\n.workspace-rich-text p {\r\n  margin: 0 0 10px;\r\n}\r\n\r\n.workspace-rich-text ul,\r\n.workspace-rich-text ol {\r\n  margin: 0 0 14px;\r\n  padding-left: 22px;\r\n}\r\n\r\n.workspace-rich-text li {\r\n  margin: 0 0 8px;\r\n}\r\n\r\n.workspace-rich-text strong {\r\n  color: #0f172a;\r\n  font-weight: 700;\r\n}\r\n\r\n.workspace-rich-text hr {\r\n  border: none;\r\n  border-top: 1px solid rgba(148, 163, 184, 0.35);\r\n  margin: 18px 0;\r\n}\r\n\r\n/* Summary modal overrides */\r\n.summary-body .workspace-rich-text h1 { font-size: 17px; margin-bottom: 6px; }\r\n.summary-body .workspace-rich-text h2 { font-size: 15px; margin-bottom: 5px; padding-bottom: 3px; }\r\n.summary-body .workspace-rich-text h3 { font-size: 14px; margin-bottom: 4px; }\r\n.summary-body .workspace-rich-text p  { margin-bottom: 5px; }\r\n.summary-body .workspace-rich-text ul,\r\n.summary-body .workspace-rich-text ol { margin-bottom: 8px; }\r\n.summary-body .workspace-rich-text li { margin-bottom: 3px; }\r\n.summary-body .workspace-rich-text,\r\n.summary-body .workspace-rich-text * { font-family: \"Times New Roman\", Times, serif; }\r\n\r\n@media (max-width: 900px) {\r\n  .documentation-body {\r\n    padding: 8px 8px 0;\r\n  }\r\n\r\n  .documentation-editor-content {\r\n    padding: 20px 18px;\r\n  }\r\n\r\n  .documentation-editor-placeholder {\r\n    left: 18px;\r\n    top: 20px;\r\n  }\r\n}\r\n\r\n\r\n.main-navbar {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr auto;\r\n  align-items: center;\r\n  gap: 10px;\r\n  min-height: 48px;\r\n  padding: 6px 12px;\r\n  background: rgba(255, 255, 255, 0.85);\r\n  backdrop-filter: blur(10px);\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1000;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.navbar-left {\r\n  display: flex;\r\n  align-items: center;\r\n  min-width: 220px;\r\n  padding-left: 0;\r\n}\r\n\r\n.navbar-center {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 0;\r\n  overflow: visible;\r\n}\r\n\r\n.navbar-right {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  min-width: fit-content;\r\n  padding-right: 0;\r\n}\r\n\r\n.navbar-right > * {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.search-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: clamp(180px, 22vw, 300px);\r\n  min-width: 0;\r\n}\r\n\r\n.search-container input {\r\n  min-width: 0;\r\n  width: 100%;\r\n}\r\n\r\n.tool-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 2px;\r\n  min-width: 0;\r\n}\r\n\r\n.tool-btn {\r\n  width: 32px;\r\n  height: 32px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.zoom-display {\r\n  min-width: 30px;\r\n  font-size: 11px;\r\n  text-align: center;\r\n}\r\n\r\n.navbar-section-divider {\r\n  width: 1px;\r\n  height: 20px;\r\n  margin: 0 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* iPad landscape (1025-1280px): keep every tool on ONE row by giving the search\r\n   box less room, instead of hiding tools. Only the narrowest widths drop the\r\n   three least-used tools. */\r\n@media (max-width: 1280px) {\r\n  .search-container {\r\n    width: clamp(150px, 16vw, 210px);\r\n  }\r\n  .main-navbar {\r\n    gap: 6px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1060px) {\r\n  .tool-btn[title=\"PDF Thumbnails\"],\r\n  .tool-btn[title=\"Summarize PDF\"],\r\n  .tool-btn[title=\"All Annotations\"] {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 1180px) {\r\n  .tool-group {\r\n    gap: 4px;\r\n  }\r\n\r\n  .tool-btn {\r\n    width: 30px;\r\n    height: 30px;\r\n  }\r\n\r\n  .navbar-section-divider {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* ── Tablet / iPad portrait (≤1024px): one-line top bar + bottom tool dock ──\r\n   Search, bookmarks and Save stay on a single top row. The drawing/annotation\r\n   tools (.navbar-center) move into a floating dock at the bottom of the screen,\r\n   the same pattern iPad note apps use. The app column reserves room for the dock\r\n   (.app-container.has-toolbar padding) so panel-anchored controls — PDF zoom pill,\r\n   workspace zoom, PDF/Split/Notes toggle — sit above it instead of under it. */\r\n@media (max-width: 1024px) {\r\n  :root {\r\n    --tool-dock-space: 68px;\r\n  }\r\n\r\n  .app-container.has-toolbar {\r\n    padding-bottom: calc(var(--tool-dock-space) + env(safe-area-inset-bottom, 0px));\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  /* backdrop-filter would make the navbar the containing block for the fixed\r\n     dock (pinning it inside the top bar), so use a solid background here. */\r\n  .main-navbar {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 8px;\r\n    padding: 6px 12px;\r\n    backdrop-filter: none;\r\n    -webkit-backdrop-filter: none;\r\n    background: rgba(255, 255, 255, 0.98);\r\n  }\r\n\r\n  /* Search takes whatever is left after the right-side buttons, and shrinks\r\n     instead of running into them */\r\n  .navbar-left {\r\n    flex: 1 1 0;\r\n    min-width: 0;\r\n  }\r\n  .navbar-left .search-wrapper {\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    max-width: 340px;\r\n  }\r\n  .navbar-left .search-container {\r\n    width: 100%;\r\n    min-width: 0;\r\n    box-sizing: border-box;\r\n  }\r\n  .navbar-right {\r\n    flex: 0 0 auto;\r\n    gap: 4px;\r\n  }\r\n\r\n  /* The dock */\r\n  .navbar-center {\r\n    position: fixed;\r\n    left: 50%;\r\n    bottom: calc(10px + env(safe-area-inset-bottom, 0px));\r\n    transform: translateX(-50%);\r\n    z-index: 1002;\r\n    width: max-content;\r\n    max-width: calc(100vw - 20px);\r\n    flex-wrap: nowrap;\r\n    justify-content: center;\r\n    gap: 2px;\r\n    padding: 5px 8px;\r\n    background: #ffffff;\r\n    border: 1px solid rgba(0, 0, 0, 0.08);\r\n    border-radius: 16px;\r\n    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.16), 0 2px 6px rgba(0, 0, 0, 0.06);\r\n    box-sizing: border-box;\r\n  }\r\n  .navbar-center .tool-group {\r\n    flex-wrap: nowrap;\r\n    gap: 2px;\r\n  }\r\n\r\n  /* Colour / page menus open UPWARD out of the dock instead of off-screen */\r\n  .navbar-center .tool-popover {\r\n    top: auto !important;\r\n    bottom: calc(100% + 10px) !important;\r\n    margin-top: 0 !important;\r\n  }\r\n\r\n  /* Side panels end above the dock instead of covering half of it */\r\n  .annotations-sidebar {\r\n    height: auto;\r\n    bottom: calc(var(--tool-dock-space) + env(safe-area-inset-bottom, 0px));\r\n  }\r\n  .bookmarks-sidebar {\r\n    height: auto !important;\r\n    bottom: calc(var(--tool-dock-space) + env(safe-area-inset-bottom, 0px));\r\n  }\r\n\r\n  /* Toasts float above the dock */\r\n  .toast-stack {\r\n    bottom: calc(var(--tool-dock-space) + 16px + env(safe-area-inset-bottom, 0px)) !important;\r\n  }\r\n\r\n  /* There's room in the dock for every tool */\r\n  .tool-btn[title=\"PDF Thumbnails\"],\r\n  .tool-btn[title=\"Summarize PDF\"],\r\n  .tool-btn[title=\"All Annotations\"] {\r\n    display: flex;\r\n  }\r\n\r\n  /* Comfortable touch targets for fingers */\r\n  .tool-btn {\r\n    width: 38px;\r\n    height: 38px;\r\n  }\r\n}\r\n\r\n/* Very narrow (small iPad split-view / phones): slightly tighter dock buttons */\r\n@media (max-width: 600px) {\r\n  .navbar-center .tool-btn {\r\n    width: 34px;\r\n    height: 34px;\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\n/* Home button (navbar, left of search) — back to the user's start page */\n.navbar-home-btn {\n  width: 34px;\n  height: 34px;\n  margin-right: 8px;\n  flex-shrink: 0;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 9px;\n  background: rgba(240, 242, 245, 0.9);\n  color: #3c4043;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n.navbar-home-btn:hover:not(:disabled) {\n  background: #e8f0fe;\n  color: #1a73e8;\n}\n.navbar-home-btn:disabled {\n  cursor: progress;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
